// Canonical load capacity per vehicle TYPE — the single source of truth for
// what a vehicle can carry, matching what customers see in the app. The
// per-vehicle `capacity` column is driver-typed free input (inconsistent, and
// deprecated), so the admin should display capacity by type instead.
const VEHICLE_CAPACITY: Record<string, string> = {
  bike: "20 kg",
  scooty: "22 kg",
  auto: "700 kg",
  pickup: "1.5 ton",
  mini_truck: "2.5 ton",
  // legacy types (kept so old vehicles still resolve)
  three_wheeler: "300 kg",
  tata_ace: "1.5 ton",
  pickup_8ft: "1.5 ton",
  tata_407: "2.5 ton",
};

/** Standard capacity label for a vehicle type (e.g. "20 kg"), or "—" if unknown. */
export const vehicleCapacityLabel = (vehicleType?: string | null): string =>
  (vehicleType && VEHICLE_CAPACITY[vehicleType.toLowerCase()]) || "—";
